import { useState } from 'react';
import llm from '../lib/llm';
import { useCustomEventListener } from 'react-custom-events';

interface SummarizeProps {
  onFinished: () => void;
}

export default function SummarizeInput({ onFinished }: SummarizeProps) {
  const [url, setUrl] = useState<string>('');

  useCustomEventListener('status',
    (data) => {
      setUrl(`${data}`);
    }
  );

  async function getSummary() {
    const summaryResult = await llm.summarizeUrl(url);
    if (summaryResult.success) {
      setUrl(`Summarized article: ${summaryResult.title}`);
    }
    else {
      setUrl(`${summaryResult.error}`);
    }
    onFinished();
  }

  // function toggleOptions(): void {
  //   setOptionsVisible(!optionsVisible);
  // }

  // async function getInitializeFromSourcesFile() {
  //   const result = await initializeFromSourcesFile();
  //   setOptionsVisible(false);
  //   setStatus(
  //     `Summarized ${result[0]} articles, ${result[1]} keywords, ${result[2]} questions, ${result[3]} errors`
  //   );
  //   replace(window.location.href);
  // }

  // async function getDeleteDatabase() {
  //   await deleteDatabase();
  //   setOptionsVisible(false);
  //   setStatus('Database deleted');
  //   replace(window.location.href);
  // }

  return (
    <>
      <div className="summarize-box">
        <input
          type="text"
          value={url}
          onFocus={(e) => e.target.select()}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Add url to summarize"
          className="input-add"
        />
        <button type="button" onClick={async () => getSummary()} className="btn-add">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
        </button>
        {/* {!optionsVisible && (
          <button
            type="button"
            className="absolute right-0 btn-options"
            onClick={() => toggleOptions()}
          >
            Options
          </button>
        )}
        {optionsVisible && (
          <div className="absolute right-0 flex flex-col">
            <button
              type="button"
              className="btn-options"
              onClick={() => toggleOptions()}
            >
              Hide options
            </button>
            <button
              type="button"
              className="btn-options"
              onClick={() => getInitializeFromSourcesFile()}
            >
              Load sources from file
            </button>
            <button
              type="button"
              className="btn-options"
              onClick={() => getDeleteDatabase()}
            >
              Delete database file
            </button>
          </div>
        )} */}
      </div>
      {/* {operationStatus && <div className="flex justify-center">{operationStatus}</div>} */}
    </>
  );
}
